import { defaultReducers, defaultInitialState } from "../../../../../redux/_common";
import { createSlice } from "@reduxjs/toolkit";
import { IState } from "./_interface";


const initialState:IState = {...defaultInitialState};
const reducers = {...defaultReducers};

export const currenciesSlice = createSlice({
  name: "currencies",
  initialState,
  reducers,
});

